import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { CountryPrizeTable, PrizeTableDTO } from '../prize-table-dtos';

@Component({
  selector: 'app-prize-table-form-field',
  templateUrl: './prize-table-form-field.component.html',
  styleUrls: ['./prize-table-form-field.component.scss'],
  standalone: false,
})
export class PrizeTableFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: CountryPrizeTable[];

  @Input() editMode: boolean = true;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  public country: number;

  public currency: number;

  public tableData: MatTableDataSource<any>;

  public displayedFieldsNames: string[];

  public fields: FieldConfigDTO[];

  public canAdd: boolean = false;

  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    if (this.router.url.includes('/lotto/')) {
      this.canAdd = true;
    }

    if (!this.data) {
      this.data = this.getInitialData();
    }

    this.formGroup.get(this.fieldConfig.name).setValue(this.data);
    this.fields = [
      {
        name: 'label',
        label: 'Label',
        type: DataType.text,
      },
      {
        name: 'odds',
        label: 'Odds',
        type: DataType.number,
      },
      {
        name: 'isJackpot',
        label: 'Is jackpot',
        type: DataType.checkbox,
      },
      {
        name: 'tierRanking',
        label: 'Tier ranking',
        type: DataType.number,
      },
      {
        name: 'prizeAmountFixed',
        label: 'Fixed prize amount',
        type: DataType.checkbox,
      },
      {
        name: 'prizeAmount',
        label: 'Fixed prize',
        type: DataType.money,
        moneyFormat: 'ticketPrice',
      },
      {
        name: 'averagePrize',
        label: 'Average prize',
        type: DataType.money,
        moneyFormat: 'fullValue',
      },
    ];
  }

  private getInitialData() {
    return [
      {
        prizeTables: [
          {
            prizeTiers: [],
          },
        ],
      },
    ];
  }

  onValueChanged(value: any[] | any) {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    const oldValue: PrizeTableDTO = formControl.value ? formControl.value : this.getInitialData();

    oldValue[0].prizeTables[0].prizeTiers = value;
    formControl.setValue(oldValue);
  }
}
